// eslint-disable-next-line no-unused-vars
import React from "react";

export default function PageNotFoundError() {
  return <h1>Oops! Page not found!</h1>;
}
